import User from "./User";
import Axios from "axios";
import moment from "moment";
import store from "../src/store";

class NewsClass {

  constructor() {
    this.news = /** @type {NewsPost[]} */ ([]);
  }

  /**
   * @param {number} id
   */
  get(id) {
    for (let post of this.news) {
      if (post.id == id) {
        return post;
      }
    }
    return null;
  }

  async init() {
    if (!User.token) {
      return;
    }
    let news = await Axios.get(CONFIG.urlServer + "/api/news", {
      params: {
        property: store.state.property,
        status: 'in_progress',
        perPage: 100
      },
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    this.news = [];
    for (let newsPost of news.data.data) {
      this.news.push(new NewsPost(newsPost));
    }
  }

  getNews() {
    return this.news;
  }

}

/**
 * @typedef NewsPostDefinition
 * @property {number} id
 * @property {{fr: string, en: string}} title
 * @property {{fr: string, en: string}} subTitle
 * @property {{fr: string, en: string}} body
 * @property {string} createdAt
 * @property {string} status
 * @property {{id: number, url: string, name: string, tag: string}} [image]
 */

export class NewsPost {

  /**
   * @param {NewsPostDefinition} definition
   */
  constructor(definition) {
    this.id = definition.id;
    this.title = definition.title;
    this.subTitle = definition.subTitle;
    this.body = definition.body;
    this.createdAt = moment(definition.createdAt);
    this.status = definition.status;
    this.documents = definition.files.filter(f => f.tag === "document");
    this.image = definition.image ? definition.image.url : null;
  }

}

let News = new NewsClass();
export default News;